import { PageType } from "~/lib/router/enums";

export const pathname = "/topic";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Topic },
    };
  },
};
